import React, { useContext } from 'react';

import { CiCircleInfo } from 'react-icons/ci';
import {
  FlexCol,
  FlexGrid,
  FlexRow,
} from '../../../../../common/components/v2';
import { Resource } from '../../../../../common/constants/resource';
import { FeatureFlagsContext } from '../../../../../common/featureFlagsWrapper';
import { Eti } from '../../../../tasks/types/eti';
import { ReasonsSummary } from '../../ReasonsSummary';
import styles from '../../styles.module.scss';

export const ETISummary = ({ eti }: { eti: Eti }) => {
  const { flags } = useContext(FeatureFlagsContext);
  const { uwNativeEtiEnabled } = flags;

  return (
    <FlexGrid>
      <FlexRow>
        <label className={styles.EvidenceTitle}>ETI</label>
      </FlexRow>
      {!uwNativeEtiEnabled && (
        <>
          <FlexRow>
            <label className={styles.DrawerSubTitle}>QUESTIONS</label>
          </FlexRow>
          <FlexRow>
            <FlexCol xs={1} sm={1} lg={1}>
              <CiCircleInfo />
            </FlexCol>
            <FlexCol xs={11} sm={11} lg={11}>
              <span className={styles.Info}>{eti.question}</span>
            </FlexCol>
          </FlexRow>
        </>
      )}
      <ReasonsSummary
        title={Resource.ORDER_REASON}
        reasons={eti.reason}
        description={eti.reasonDescription}
      />
    </FlexGrid>
  );
};
